/**
 * aiAgentBridge — 轻量单例，用于跨组件树调用 AIAgent 面板。
 *
 * GeneralAIAgent 在挂载时注册自己，卸载时注销。
 * GlobalSearchDialog（或其他任何地方）通过 openWithAgent 触发。
 */

// eslint-disable-next-line no-underscore-dangle
let _handler = null;

/**
 * 由 GeneralAIAgent 调用，注册打开面板并选中 agent 的能力。
 * @param {{ openWithAgent: (agentId: string, prefillText: string) => void }} handler
 */
export function registerAIAgentHandler(handler) {
  _handler = handler;
}

export function unregisterAIAgentHandler() {
  _handler = null;
}

/**
 * 由 GlobalSearchDialog 等调用方用来判断 agents 功能是否已开启。
 * @returns {boolean}
 */
export function hasAIAgentHandler() {
  return _handler !== null;
}

/**
 * 打开 AI Agent 面板，选中指定 agent，并在输入框预填文本（不自动发送，等用户按回车）。
 * @param {string} agentId
 * @param {string} prefillText
 * @returns {boolean} 是否成功（handler 未注册时返回 false）
 */
export function openAIAgentWithAgent(agentId, prefillText) {
  if (!_handler) return false;
  _handler.openWithAgent(agentId, prefillText);
  return true;
}
